var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.929,
    height: 20.967,
    viewBox: "0 0 20.929 20.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expenses",
    transform: "translate(-425.91 -419.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M444.739,561.846h-3.374a1.643,1.643,0,0,0-1.88,1.556,4.825,4.825,0,0,0,.065,2.156,1.566,1.566,0,0,0,1.652,1.261c1.11,0,2.22,0,3.329,0h.191c.007.066.016.122.016.178,0,.636,0,1.273,0,1.909a1.773,1.773,0,0,1-1.827,1.82q-7.591,0-15.182,0a1.77,1.77,0,0,1-1.817-1.829q0-4.562,0-9.125a1.77,1.77,0,0,1,1.832-1.836q7.58,0,15.16,0a1.772,1.772,0,0,1,1.835,1.834C444.741,560.453,444.739,561.133,444.739,561.846Z",
    transform: "translate(0 -129.918)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M477.95,455.537c.429-.377.809-.712,1.191-1.047q2.461-2.157,4.922-4.314a1.015,1.015,0,0,1,1.163-.231,1.081,1.081,0,0,1,.658,1.064c0,.429-.005.858,0,1.287a.254.254,0,0,1-.163.272q-2.918,1.447-5.831,2.9a.55.55,0,0,1-.23.063C479.115,455.539,478.568,455.537,477.95,455.537Z",
    transform: "translate(-48.959 -28.228)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M668.982,639.518h-1.952c-.727,0-1-.215-1.137-.934a4.506,4.506,0,0,1,.02-1.785.907.907,0,0,1,1.041-.833q2.063,0,4.125,0a1.067,1.067,0,0,1,1.138,1.139c0,.436,0,.873,0,1.309a1.065,1.065,0,0,1-1.105,1.1C670.4,639.521,669.692,639.518,668.982,639.518Zm-1.047-.356a1.421,1.421,0,1,0-1.4-1.446A1.425,1.425,0,0,0,667.935,639.162Z",
    transform: "translate(-225.702 -203.327)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M703.538,426.6l-1.418-1.064a2.634,2.634,0,0,0,1.414-2.847c-.261,0-.505.015-.746-.007a.4.4,0,0,1-.282-.154.347.347,0,0,1,.057-.295q.775-1.068,1.571-2.123a.53.53,0,0,1,.922.007c.523.7,1.045,1.4,1.558,2.105.06.083.109.243.068.311a.439.439,0,0,1-.306.149c-.226.022-.456.007-.7.007A4.726,4.726,0,0,1,703.538,426.6Z",
    transform: "translate(-259.859)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M543.942,495.2H536.28c.093-.054.144-.088.2-.115q2.924-1.459,5.849-2.916a1.065,1.065,0,0,1,1.628,1.013q0,.976,0,1.952A.531.531,0,0,1,543.942,495.2Z",
    transform: "translate(-103.837 -67.904)",
    fill: "#1c2b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M690.687,653.99a.71.71,0,1,1-.707.707A.715.715,0,0,1,690.687,653.99Z",
    transform: "translate(-248.438 -220.285)",
    fill: "#1c2b3e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.43f296df775c286cc7e131bb2ab1fe86.svg";
export { ForwardRef as ReactComponent };